import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import Sidebar from "./sidebar";
import PageHeader from "./page-header";
import Panel from "./panel";
import { $, style, merge, media, presets } from "glamor";
import theme from "styles/theme";
import classNames from "classnames";

/** @augments {Component<any, any>} */
class Page extends Component {
    static contextTypes = {
        me: PropTypes.object,
        app: PropTypes.object.isRequired,
        viewport: PropTypes.string.isRequired, // hope to phase this out
    };

    static propTypes = {
        viewport: PropTypes.string,
        sidebarSections: PropTypes.array, // sidebar sections
        title: PropTypes.string,
        titleComponent: PropTypes.object,
        headerKey: PropTypes.string, // used to force update title
        showTitle: PropTypes.bool,
        openNavSection: PropTypes.string,
        hasPageHeader: PropTypes.bool,
        searchScope: PropTypes.string,
        defaultSearchTerm: PropTypes.string,
        onSearch: PropTypes.func,
        actions: PropTypes.element,
        badge: PropTypes.element,
        breadcrumbs: PropTypes.array,
        editableTitle: PropTypes.bool,
        onTitleChange: PropTypes.func,
        titleChangeTimeout: PropTypes.number,
        editableTitleFocused: PropTypes.bool,
        placeholder: PropTypes.string,
        showHeader: PropTypes.bool,
        className: PropTypes.string,
        notificationPanel: PropTypes.element,
        headerNotificationPanel: PropTypes.element,
        panel: PropTypes.node, // will replace sidebar
        panelSize: PropTypes.number,
        horizontalScrollable: PropTypes.bool,
        fixedHeader: PropTypes.bool,
        headerStyles: PropTypes.object,
        crumbsStyles: PropTypes.object,
        titleTextStyles: PropTypes.object,
    };

    static defaultProps = {
        hasPageHeader: true,
        showTitle: true,
        title: "",
        headerKey: null,
        editableTitleFocused: false,
        showHeader: true,
        showInlineHeader: false,
        notificationPanel: null,
        panelSize: 234,
    };

    static childContextTypes = {
        sidebarSections: PropTypes.array,
    };

    styles = merge(
        {
            minHeight: "100%",
            height: "100%",
        },
        $(" .layoutContainer", {
            display: "flex",
            minHeight: "100%",
            height: "100%",
        }),
        $(" .layoutContainerMain", {
            flexGrow: 1,
            flexShrink: 0,
            padding: "0 8px",
            maxWidth: "100%",
            minHeight: "100%",
            height: "100%",
        }),
        $(" .layoutContainerMain.sidebar", {
            maxWidth: "calc(100% - 234px)",
        }),
        $(" .dashboard.isPinned", {
            maxWidth: "calc(100vw - 260px)",
        }),
        $(" .dashboard.isMobile", {
            maxWidth: "100vw",
        }),
        $(" .dashboard.isFullWidth", {
            maxWidth: "calc(100vw - 90px)",
        }),
        $(" .dashboard.isDefaultWidth", {
            maxWidth: "1180px",
        }),
        media(
            presets.phablet,
            merge(
                $(" .layoutContainerMain", {
                    padding: "0 8px",
                })
            )
        )
    );

    getChildContext() {
        return {
            sidebarSections: this.props.sidebarSections,
        };
    }

    UNSAFE_componentWillMount() {
        this.updateAppbar();
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (
            nextProps.title !== this.props.title ||
            nextProps.searchScope !== this.props.searchScope ||
            nextProps.openNavSection !== this.props.openNavSection
        ) {
            this.updateAppbar(nextProps, nextContext);
        }
    }

    updateAppbar(props = this.props, context = this.context) {
        const { app } = context;
        if (app) {
            app.trigger("change:page", {
                title: props.title,
                openNavSection: props.openNavSection,
                searchScope: props.searchScope,
            });
        }
    }

    render() {
        const {
            title,
            titleComponent,
            sidebarSections,
            children,
            hasPageHeader,
            actions,
            badge,
            breadcrumbs,
            hideSideBarDividers,
            editableTitle,
            onTitleChange,
            titleChangeTimeout,
            showTitle,
            headerKey,
            editableTitleFocused,
            showHeader,
            placeholder,
            panel,
            panelSize,
            horizontalScrollable: horizontalScrollable = false,
            fixedHeader,
            headerStyles,
            crumbsStyles,
            titleTextStyles,
            notificationPanel,
            headerNotificationPanel,
            newPdPdrawerForOrderInsightsNu67228,
        } = this.props;

        // merge the panel's styles here because the maxWidth need to be calculated based on the panelSize
        const styles = newPdPdrawerForOrderInsightsNu67228
            ? this.styles
            : merge(
                  this.styles,
                  $(".panel", {
                      maxWidth: `calc(100% - ${this.props.panelSize}px)`,
                  })
              );

        const viewport = this.props.viewport || this.context.viewport;

        let pageHeader;
        if (hasPageHeader && showHeader) {
            pageHeader = (
                <PageHeader
                    key={headerKey}
                    title={title}
                    titleComponent={titleComponent}
                    editableTitle={editableTitle}
                    editableTitleFocused={editableTitleFocused}
                    showTitle={showTitle}
                    breadcrumbs={breadcrumbs}
                    actions={actions}
                    badge={badge}
                    fixedHeader={fixedHeader}
                    onTitleChange={onTitleChange}
                    titleChangeTimeout={titleChangeTimeout}
                    placeholder={placeholder}
                    viewport={viewport}
                    headerStyles={headerStyles}
                    crumbsStyles={crumbsStyles}
                    titleTextStyles={titleTextStyles}
                />
            );
        }

        let sidebar;
        const isMobile = ["mobile", "phablet"].includes(viewport);
        if (!panel && sidebarSections && !isMobile) {
            sidebar = <Sidebar hideDividers={hideSideBarDividers}>{sidebarSections}</Sidebar>;
        }

        return (
            <div {...styles} className={classNames({ panel }, this.props.className)}>
                {headerNotificationPanel}
                {pageHeader}
                {notificationPanel}
                {panel && <Panel panelSize={panelSize}>{panel}</Panel>}
                <div
                    className="layoutContainer"
                    style={{
                        paddingTop: fixedHeader ? theme.appBar.height + "px" : 0,
                    }}
                >
                    {sidebar}
                    <div
                        key="layoutContainerMain"
                        className={classNames("layoutContainerMain", { widthSidebar: sidebar })}
                        style={this.props.bodyStyle}
                        {...merge(
                            !horizontalScrollable && style({ maxWidth: "100%" }),
                            sidebar && !horizontalScrollable && style({ maxWidth: "calc(100% - 234px)" })
                        )}
                    >
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    newPdPdrawerForOrderInsightsNu67228: state.ldFlags.newPdPdrawerForOrderInsightsNu67228,
});

export const ConnectedPage = connect(mapStateToProps)(Page);

export default Page;
